module.exports = __webpack_public_path__ + "img/university_3.1441eb92.png";